import * as React from 'react';
import * as classNames from 'classnames';
import {ICommonCommentItem, ICommonReplyItem} from '../../../../apis/comment/commonApiAdapter';
import {isLiked, setLiked} from '../../../../common/like';

if (process.env.BROWSER) {
  require('./index.less');
}

export interface ICommentOptionProp {
  type?: 'comment' | 'reply';
  commentItem?: ICommonCommentItem;
  replyItem?: ICommonReplyItem;
  like?: number;
  // likedByUser?: boolean;
  reply: number;
  onLikeItem: (type: 'comment' | 'reply', item: ICommonCommentItem|ICommonReplyItem) => any;
}

export interface ICommentOptionState {
  liked: boolean;
  like: number;
}

export default class CommentOption extends React.Component<ICommentOptionProp, ICommentOptionState> {
  constructor(p) {
    super(p);
    this.state = {
      liked: false,
      like: this.props.like || 0,
    };
  }

  public keyOfLike() {
    let keys: any[] = [this.props.type, this.props.commentItem.itemId];
    if (this.props.type === 'comment') {
      keys = keys.concat([
        this.props.commentItem.commentId,
      ]);
    } else {
      keys = keys.concat([
        this.props.replyItem.commentId,
        this.props.replyItem.replyId,
      ]);
    }
    return keys;
  }

  public componentDidMount(): void {
    if (isLiked(this.keyOfLike())) {
      this.setState({
        liked: true,
      });
    }
  }

  public onClickLike() {
    if (!this.state.liked) {
      setLiked(this.keyOfLike(), true);
      this.props.onLikeItem(this.props.type, this.props.type === 'comment' ? this.props.commentItem : this.props.replyItem);
      this.setState({
        liked: true,
        like: this.state.like + 1,
      });
    }
  }

  public render(): JSX.Element {
    return (<div className={'comment-item-option'}>

      <i className={classNames(['comment-item-like', {liked: this.state.liked}])} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.onClickLike();
      }}>
        <b className="text">{this.state.like}</b>
        <b className="addone">+1</b>
      </i>

      <i className={'comment-item-replycount'}>
        {this.props.reply}
      </i>
    </div>);
  }
}
